import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

// Mapping route publique → source analytics
const ROUTE_TO_SOURCE = {
  "/": "marketing:home",
  "/wall": "walltunes",
  "/offre-pwa": "marketing:offer-pwa",
  "/offre-stream": "marketing:offer-stream",
  "/contact": "marketing:contact",
  "/now-playing": "marketing:now-playing",
};

/**
 * Tracker global monté dans App.js.
 * À chaque changement de route, envoie un beacon anonyme au backend si
 * la route correspond à une page publique (jamais sur /admin/*).
 */
export function PageTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    const source = ROUTE_TO_SOURCE[pathname];
    if (source) trackPageView(source);
  }, [pathname]);
  return null;
}
